<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      @resetBtn="resetBtn"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:warehouseId>
        <el-select
          multiple
          filterable
          v-model="filters.warehouseId"
          placeholder="请选择仓库"
          collapse-tags
        >
          <el-option
            v-for="item in warehouseList"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:status>
        <el-select
          multiple
          filterable
          v-model="filters.status"
          placeholder="请选择状态"
          collapse-tags
        >
          <el-option
            v-for="item in statuslist"
            :label="item.loadCarStatusText"
            :value="item.loadCarStatusId"
            :key="item.loadCarStatusId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:transportType>
        <el-select
          multiple
          v-model="filters.transportType"
          placeholder="请选择运输方式"
          collapse-tags
        >
          <el-option
            v-for="item in transportList"
            :label="item.transportTypeText"
            :value="item.transportTypeText"
            :key="item.transportTypeText"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:tdate>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>

      <template slot-scope="scope" slot="loadCarNo">
        <el-link
          :underline="false"
          type="primary"
          @click.native="viewloadingReviewdialog(scope.row.loadCarInfoID)"
          >{{ scope.row.loadCarNo }}
        </el-link>
      </template>
      <template slot-scope="scope" slot="file">
        <div>
          <span>照片:</span>
          <span v-if="scope.row.isLoading > 0">
            <el-link
              :underline="false"
              type="primary"
              @click.native="getReadyImages(scope.row.loadCarInfoID)"
            >
              预览
            </el-link>
            <el-link
              style="margin-left: 5px"
              :underline="false"
              type="primary"
              @click.native="handleImages(scope.row.loadCarInfoID)"
            >
              下载
            </el-link>
          </span>
          <br />
        </div>
      </template>
      <template slot-scope="scope" slot="abnormal">
        <div>
          <span v-if="scope.row.isAbnormal == true" style="color: red">
            {{ scope.row.isAbnormalText }}
          </span>
          <span v-else> {{ scope.row.isAbnormalText }}</span>
        </div>
      </template>

      <template slot-scope="scope" slot="operatorInfo">
          <span>装车:{{ scope.row.loadUser }}</span>
          <br />
          <span>复核:{{ scope.row.outUser }}</span>
      </template>
      <template v-slot:realName>
        <el-select multiple v-model="filters.realName" filterable placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in userList"
            :label="item.realName"
            :value="item.realName"
            :key="item.realName"
          ></el-option>
        </el-select>
      </template>
    </TwTable>
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{
        businessType: 29,
        businessCode: currentRow.loadCarNo,
      }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>
    <!-- 装车单 -->
    <el-dialog
      id="completeDialog"
      title="装车单"
      :visible.sync="addTaskdialogVisible"
      width="90%"
      top="70px"
      style="text-align: center"
    >
      <div id="completeDiv">
        <iframe
          :src="completeTask"
          height="700"
          width="100%"
          style="border: none"
        ></iframe>
      </div>
    </el-dialog>

    <!-- 打印装车单 -->
    <el-dialog
      :visible.sync="printPickListVisible"
      v-model="printPickListVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="打印装车单"
      :width="'400mm'"
      :height="'250mm'"
      style="text-align: center"
    >
      <el-row>
        <div class="print" style="float: right">
          <el-button
            type="primary"
            v-print="'printTable'"
            @click="printLoadCar()"
            >打印</el-button
          >
        </div>
      </el-row>
      <div id="printTable">
        <div class="printTitleWarpper">
          <el-row type="flex" class="row-bg printTitle">
            <el-col :span="8"
              ><div class="grid-content bg-purple" style="text-align: left">
                <strong
                  >单号:{{ carInfoPrint.loadCarNo }}({{
                    carInfoPrint.referenceNo
                  }})</strong
                >
              </div></el-col
            >
            <el-col :span="6"
              ><div class="grid-content bg-purple" style="text-align: left">
                <strong
                  >预计装柜：{{ carInfoPrint.expectedLoadTimeDesc }}</strong
                >
              </div></el-col
            >
            <el-col :span="8"
              ><div class="grid-content bg-purple" style="text-align: left">
                <strong
                  >箱数/体积/重量：{{ carInfoPrint.pcsQty }}件/{{
                    carInfoPrint.volume
                  }}CMB/{{ carInfoPrint.grossWeight }}KG</strong
                >
              </div></el-col
            >
          </el-row>
          <el-row type="flex" class="row-bg printTitle">
            <el-col :span="8"
              ><div class="grid-content bg-purple" style="text-align: left">
                <strong
                  >柜号/封条号：{{ carInfoPrint.containerNumber }}/{{
                    carInfoPrint.sealNumber
                  }}</strong
                >
              </div></el-col
            >
            <el-col :span="6"
              ><div class="grid-content bg-purple" style="text-align: left">
                <strong
                  >SO:{{ carInfoPrint.soNumber }}
                  {{ carInfoPrint.transportType }}:{{
                    carInfoPrint.cabinetType
                  }}</strong
                >
              </div></el-col
            >
            <el-col :span="8"
              ><div class="grid-content bg-purple" style="text-align: left">
                <strong
                  >司机信息：{{ carInfoPrint.carNumber }}/{{
                    carInfoPrint.driver
                  }}/{{ carInfoPrint.driverPhone }}</strong
                >
              </div></el-col
            >
          </el-row>
        </div>
        <PrintTable :data="boxPrint" :columns="printColumns">
          <template slot-scope="scope" slot="sku">
            {{ scope.row.sku }}<br />
            /{{ scope.row.inStockSKUCode }}
          </template>
          <template slot-scope="scope" slot="brand">
            {{ scope.row.containerNo }}
          </template>
          <template slot-scope="scope" slot="fnsku">
            {{ scope.row.fnsku }}/
            {{ scope.row.shipmentID }}
          </template>
        </PrintTable>
      </div>
    </el-dialog>
    <!-- 预览图片 -->
    <div>
      <viewer :images="srcList" class="viewer" ref="viewer" @inited="inited">
        <img v-for="(src, index) in srcList" :src="src" :key="index" />
      </viewer>
    </div>
    <el-dialog
      id="loadingReviewdialog"
      :title="loadingReviewdialogTitle"
      :close-on-click-modal="false"
      :visible.sync="loadingReviewdialogVisible"
      class="dialogClass"
      style="text-align: center; overflow-y: hidden"
      :fullscreen="true"
    >
      <div id="completeDivd" style="overflow-x: hidden">
        <iframe
          :src="loadingReviewWinodw"
          width="100%"
          :height="loadingReviewWinodwheight"
          frameborder="0"
          style="overflow-x: hidden"
        ></iframe>
      </div>
    </el-dialog>

    <!--  -->
    <el-dialog
      title="手动发货通知"
      :visible.sync="editPutCarDriverInfoVisible"
      v-model="editPutCarDriverInfoVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      width="70%"
    >
      <el-form
        :model="editPutCarDriverInfoForm"
        ref="editPutCarDriverInfoForm"
        label-width="80px"
      >
        <el-card shadow="hover" style="margin-top: 10px; width: 100%">
          <div slot="header" class="clearfix">
            <span>物流信息</span>
          </div>
          <el-row>
            <el-col :span="12">
              <el-form-item>
                <el-link type="warning">请正确核对物流信息</el-link>[{{
                  editPutCarDriverInfoForm.loadCarNo
                }}]
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <el-form-item label="柜型" prop="containerType">
                <el-select
                  v-model="editPutCarDriverInfoForm.cabinetType"
                  :disabled="
                    editPutCarDriverInfoForm.status == 50 ? true : false
                  "
                >
                  <el-option
                    v-for="item in ContainerTypeList"
                    :label="item.text"
                    :value="item.text"
                    :key="item.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="柜号：" prop="containerNumber">
                <el-input
                  v-model="editPutCarDriverInfoForm.containerNumber"
                  auto-complete="off"
                  placeholder="请输入柜号"
                  maxlength="50"
                  :readonly="editPutCarDriverInfoForm.status == 50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="封条号：" prop="sealNumber">
                <el-input
                  v-model="editPutCarDriverInfoForm.sealNumber"
                  auto-complete="off"
                  placeholder="请输入封条号"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="SO：" prop="soNumber">
                <el-input
                  v-model="editPutCarDriverInfoForm.soNumber"
                  auto-complete="off"
                  placeholder="请输入SO"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="车牌：" prop="carNumber">
                <el-input
                  v-model="editPutCarDriverInfoForm.carNumber"
                  auto-complete="off"
                  placeholder="请输入车牌"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="司机：" prop="driver">
                <el-input
                  v-model="editPutCarDriverInfoForm.driver"
                  auto-complete="off"
                  placeholder="请输入司机"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电话：" prop="driverPhone">
                <el-input
                  v-model="editPutCarDriverInfoForm.driverPhone"
                  auto-complete="off"
                  placeholder="请输入电话"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <el-card shadow="hover" style="margin-top: 10px; width: 100%">
          <div style="text-align: center">
            <el-button type="primary" @click="editPutCarDriverInfoSubmit"
              >提交</el-button
            >
            <el-button @click="editPutCarDriverInfoVisible = false"
              >取消</el-button
            >
          </div>
        </el-card>
      </el-form>
    </el-dialog>
  </div>
</template>
<style>
figure {
  page-break-inside: avoid;
}
.viewer-list > li {
  width: 80px;
}
.viewer {
  display: none;
}
.printTitle {
  font-size: 16px;
  padding-top: 5px;
}
.printTitleWarpper {
  margin-bottom: 20px;
}
</style>
<script>
import {
  getLoadCarInfoAsync,
  exportLoadCarInfoAsyncOut,
  getLoadCarInfoReviewImages,
  getLoadCarInfoReviewImagesFileOut,
  deleteLoadCarInfo,
  getLoadCarInfoPrint,
  loadCarInfoStatusPrint,
  judgeLoadCarInfoIsAbnormal,
  GetPutCarDriverInfo,
  SaveMakeUpLogisticsInfo,
  rollBackLoadCar,
} from "@/api/outbound/loadingOrder.js";
import { getReadyforTaskBasis } from "@/api/outbound/readyforTask.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";
import { GetContainerTypeList } from "@/api/common/common.js";
import PrintTable from "../../components/printTable.vue";
import html2canvas from "html2canvas";
import printJS from "print-js";
import {getOperatorInfo} from "@/api/api.js";

export default {
  components: { LogDialog, TwTable, PrintTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      userList: [],
      printObj: {
        id: "printMe",
        popTitle: "拣货单",
        extraCss: "https://www.google.com,https://www.google.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      printColumns: [
        {
          prop: "sku",
          label: "SKU/调入SKU",
          minWidth: "150",
          slot: true,
        },
        {
          prop: "brand",
          label: "临柜号",
          minWidth: "100",
          slot: true,
        },
        {
          prop: "fnsku",
          label: "FNSKU/唛头",
          minWidth: "100",
          slot: true,
        },
        {
          prop: "singleBoxQty",
          label: "单箱",
          minWidth: "40",
        },
        {
          prop: "volumn",
          label: "体积",
          minWidth: "60",
        },
        {
          prop: "weight",
          label: "重量",
          minWidth: "60",
        },
        {
          prop: "boxNo",
          label: "箱号",
          minWidth: "50",
        },
        {
          prop: "selCount",
          label: "件数",
          minWidth: "40",
        },
        {
          prop: "actualCount",
          label: "实发件数",
          minWidth: "310",
        },
        {
          prop: "remark",
          label: "仓库备注",
          minWidth: "80",
        },
      ],
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          options: [
            {
              name: "日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置

          {
            prop: "loadCarNo",
            label: "装车单号",
            align: "center",
            sortable: true,
            minWidth: "150",
            slot: true,
          },
          {
            prop: "transportType",
            label: "运输方式",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "referenceNo",
            label: "参考单号",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            label: "物流信息",
            minWidth: "170",
            formatter: function (val, row) {
              return (
                "<span>封条号:" +
                (row.sealNumber || "") +
                "</span><br /><span>SO号:" +
                (row.soNumber || "") +
                "</span><br /> <span>柜号:" +
                (row.containerNumber || "") +
                "</span><br />"
              );
            },
          },
          {
            prop: "statusText",
            label: "状态",
            align: "center",
            sortable: true,
            minWidth: "90",
          },
          {
            prop: "customName",
            label: "客户",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            label: "转运信息",
            minWidth: "200",
            formatter: function (val, row) {
              return (
                "<span>预约到达:" +
                (row.deliveryDate || "") +
                "</span><br /><span>车牌号:" +
                (row.carNumber || "") +
                "</span><br /> <span>司机:" +
                (row.driver || "") +
                "</span><br /><span>电话:" +
                (row.driverPhone || "") +
                "</span><br />"
              );
            },
          },
          {
            prop: "operatorInfo",
            label: "操作人",
            slot: true,
            minWidth: "100",
          },
          {
            label: "操作节点",
            minWidth: "200",
            formatter: function (val, row) {
              return (
                "<span>创建时间:" +
                (row.createTime || "") +
                "</span><br /><span>预计装车:" +
                (row.expectedLoadTime || "") +
                "</span><br /> <span>实际装车:" +
                (row.actualLoadTime || "") +
                "</span><br /><span>复核时间:" +
                (row.checkTime || "") +
                "</span><br />"
              );
            },
          },
          {
            prop: "file",
            label: "附件",
            slot: true,
            minWidth: "120",
          },

          {
            label: "装载信息",
            minWidth: "130",
            formatter: function (val, row) {
              return (
                "<span>件数:" +
                (row.pcsQty || "") +
                "</span><br /><span>体积:" +
                (row.volume + "cbm" || "") +
                "</span><br /> <span>毛重:" +
                (row.grossWeight + "kg" || "") +
                "</span><br />"
              );
            },
          },
          {
            prop: "abnormal",
            label: "是否异常",
            minWidth: "110",
            slot: true,
            sortable: true,
          },
        ],
      },
      loadingReviewWinodw: "",
      loadingReviewWinodwheight: 800,
      loadingReviewdialogVisible: false,
      searchData: {
        //搜索列配置

        search: [
          {
            type: "input",
            key: "loadCarNo",
            label: "装车单号",
            placeholder: "请输入装车单号",
            clearable: true,
          },
          {
            type: "input",
            key: "referenceNo",
            label: "参考单号",
            placeholder: "请输入参考单号",
            clearable: true,
          },

          {
            type: "select",
            key: "status",
            prop: "status",
            label: "状态",
            multiple: true,
            slot: true,
            placeholder: "请选择状态",
            option: this.statuslist,
          },

          {
            type: "select",
            key: "transportType",
            prop: "transportType",
            label: "运输方式",
            multiple: true,
            slot: true,
            placeholder: "请选择运输方式",
            option: this.transportList,
          },
         
        ],
        ///高级搜索配置
        moreSearch: [ {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "装车时间",
          },
           {
            type: "select",
            key: "realName",
            prop: "realName",
            label: "操作人",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.userList,
          },],
      },
      buttonList: [],

      //-------------
      warehouseList: [],
      transportList: [],
      statuslist: [],
      srcList: [],
      addTaskdialogVisible: false,
      carInfoPrint: {},
      boxPrint: [],
      printPickListVisible: false,
      editPutCarDriverInfoVisible: false,
      editPutCarDriverInfoForm: {},
      ContainerTypeList: [],
      completeTask: "/Outbound/AddLoadingOrder",
      loadingReviewdialogTitle: "装车单详情",
    };
  },

  created() {
    // 监听子组件的关闭事件
    window.addEventListener(
      "message",
      () => {
        this.closeSelf();
        this.closeReviewdialogVisible();
      },
      false
    );
  },
  methods: {
    resetBtn() {
      this.filters = {};
    },

    toPrint() {
      printJS({
        printable: this.$refs.printContent, // 'printFrom', // 标签元素id
        type: "html",
        header: "表单",
        targetStyles: ["*"],
        style: "@page {margin:0 10mm};", // 可选-打印时去掉眉页眉尾
        ignoreElements: [], // ['no-print']
        properties: null,
      });
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    closeReviewdialogVisible() {
      // 关闭当前弹框
      this.loadingReviewdialogVisible = false;

      this.initTable();
    },
    addBoxMark(loadCarInfoID) {
      var random = Math.random();
      this.completeTask =
        "/Outbound/AddLoadingOrder?random=" +
        random +
        "&type=2&loadCarInfoID=" +
        loadCarInfoID;
      this.addTaskdialogVisible = true;
    },
    // 弹出添加装车单
    addTaskdialog() {
      this.completeTask = "/Outbound/AddLoadingOrder";
      this.addTaskdialogVisible = true;
    },
    // 弹出修改装车单
    editTaskdialog() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      if (
        this.selectRows.rows[0].stockingStatus == 40 ||
        this.selectRows.rows[0].stockingStatus == 50
      ) {
        this.$message({
          message: "【已装车】【已复核】的装车单不允许修改",
          type: "error",
        });
        return;
      }

      let loadCarInfoID = row[0].loadCarInfoID;
      judgeLoadCarInfoIsAbnormal({
        loadCarInfoID: loadCarInfoID,
      }).then((res) => {
        console.log(res);

        if (res.data.success) {
          var random = Math.random();
          this.completeTask =
            "/Outbound/AddLoadingOrder?random=" +
            random +
            "&type=1&loadCarInfoID=" +
            loadCarInfoID;
          this.addTaskdialogVisible = true;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    closeSelf() {
      // 关闭当前弹框
      this.addTaskdialogVisible = false;
      this.initTable();
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },

    viewloadingReviewdialog(loadCarInfoID) {
      this.loadingReviewdialogTitle = "装车单详情";
      var random = Math.random();

      this.loadingReviewWinodw =
        "/Outbound/LoadingReview?random=" +
        random +
        "&loadCarInfoID=" +
        loadCarInfoID +
        "&viewtype=0";

      var h =
        document.documentElement.clientHeight || document.body.clientHeight;

      this.loadingReviewWinodwheight = h - 140; //减去页面上固定高度height

      this.loadingReviewdialogVisible = true;
    },

    loadingReviewdialog() {
      this.loadingReviewdialogTitle = "复核装车单";
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].status != 40) {
        this.$message({
          message: "请选择状态是【已装车】的数据！",
          type: "error",
        });
        return;
      }
      var random = Math.random();
      this.loadingReviewWinodw =
        "/Outbound/LoadingReview?random=" +
        random +
        "&loadCarInfoID=" +
        row[0].loadCarInfoID +
        "&viewtype=1";

      var h =
        document.documentElement.clientHeight || document.body.clientHeight;

      this.loadingReviewWinodwheight = h - 140; //减去页面上固定高度height

      this.loadingReviewdialogVisible = true;
    },
    //回滚装车单
    rollBackLoadCar() {
      if (this.selectRows.rows == null || this.selectRows.rows.length != 1) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if (![50].includes(this.selectRows.rows[0].status)) {
        this.$message({
          message: "请选择状态为【已复核】装车单！",
          type: "error",
        });

        return;
      }
      var loadCarNos = this.selectRows.rows
        .map((item) => item.loadCarNo)
        .join(",");
      this.$confirm(
        "确认回滚装车单[" + loadCarNos + "]吗?(回滚后箱子需重新扫描)",
        "提示",
        {}
      )
        .then(() => {
          var para = {
            loadCarInfoID: this.selectRows.rows[0].loadCarInfoID,
          };

          rollBackLoadCar(para).then((res) => {
            console.log(res);
            if (res.data.success) {
              this.initTable();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //查询列表
    initTable() {
      const {
        loadCarNo,
        referenceNo,
        transportType,
        warehouseId,
        tdate,
        status,
        realName,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        transportType: thereAre(transportType),
        warehouseId: thereAre(warehouseId),
        loadCarNo,
        referenceNo,
        status: thereAre(status),
        realName:thereAre(realName),
      };
      if (tdate != null && tdate != "null") {
        para.startdate = tdate[0];
        para.enddate = tdate[1];
      }

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getLoadCarInfoAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;

      let loadCarInfoIDs = "";
      row.forEach((item) => {
        loadCarInfoIDs += item.loadCarInfoID + ",";
      });

      const {
        loadCarNo,
        referenceNo,
        transportType,
        warehouseId,
        tdate,
        status,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: 60001,
        transportType: thereAre(transportType),
        warehouseId: thereAre(warehouseId),
        loadCarNo,
        referenceNo,
        loadCarInfoIDs: thereAre(loadCarInfoIDs),
        status: thereAre(status),
      };
      if (tdate != null && tdate != "null") {
        para.startdate = tdate[0];
        para.enddate = tdate[1];
      }

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: exportLoadCarInfoAsyncOut,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    //预览图片
    getReadyImages(id) {
      const data = {
        loadCarInfoID: id,
      };
      //this.showPreviewImg = false;
      this.srcList = [];

      const loading = this.$loading({
        lock: true,
        text: "图片加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      getLoadCarInfoReviewImages(data).then((res) => {
        console.log(res);
        loading.close();
        if (res.data.status === 200 && res.data.success) {
          const { response } = res.data;
          response.forEach((item, i) => {
            response[i] = `data:image/png;base64,${item}`;
          });
          this.srcList = response;
          this.$viewer.view(0);
          this.$viewer.show();
        } else {
          this.$message({
            message: "加载失败！",
            type: "error",
          });
        }
      });
    },
    //下载照片
    handleImages(id) {
      const data = {
        loadCarInfoID: id,
      };

      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(getLoadCarInfoReviewImagesFileOut, {
          params: data,
        })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //删除装车单
    deleteLoad() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (
        this.selectRows.rows[0].status > 30
      ) {
        this.$message({
          message: "装车完成不允许取消",
          type: "error",
        });
        return;
      }
      this.$confirm(
        "确认要删除装车单" + row[0].loadCarNo + "吗？该状态为["+ row[0].statusText+"]",
        "提示",
        {}
      ).then(() => {
        deleteLoadCarInfo({
          loadCarInfoID: row[0].loadCarInfoID,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.initTable();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
    //打印装车单查询
    printPickList() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      getLoadCarInfoPrint({
        loadCarInfoID: row[0].loadCarInfoID,
      }).then((res) => {
        if (res.data.success) {
          this.printPickListVisible = true;
          this.boxPrint = res.data.response.loadCarPrintList;
          this.carInfoPrint = res.data.response;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //打印装车单
    printLoadCar() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      var that = this;
      loadCarInfoStatusPrint({
        loadCarInfoID: row[0].loadCarInfoID,
      }).then((res) => {
        if (res.data.success) {
          // that.toPrint();
          this.initTable();
          this.printPickListVisible = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //加载基础资料
    getBasicdatalist() {
      let user = JSON.parse(window.localStorage.user);
      this.warehouseList = user.warehouseList;
      getReadyforTaskBasis("").then((res) => {
        this.transportList = res.data.response.transportdata;
        this.statuslist = res.data.response.loadCarStatusdata;
      });
    },

    editPutCarDriverInfoSubmit() {
      const that = this;

      if (
        that.editPutCarDriverInfoForm.carNumber != null &&
        that.editPutCarDriverInfoForm.carNumber != ""
      ) {
        let regcarNumber =
          /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$/;
        if (!regcarNumber.test(that.editPutCarDriverInfoForm.carNumber)) {
          this.$message({
            message: "请输入正确的车牌号",
            type: "error",
          });
          return false;
        }
      }

      if (
        that.editPutCarDriverInfoForm.driverPhone != null &&
        that.editPutCarDriverInfoForm.driverPhone != ""
      ) {
        let regdriverPhone =
          /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(14[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
        if (!regdriverPhone.test(that.editPutCarDriverInfoForm.driverPhone)) {
          this.$message({
            message: "请输入正确的电话号码",
            type: "error",
          });
          return false;
        }
      }
      if (
        that.editPutCarDriverInfoForm.containerNumber != null &&
        that.editPutCarDriverInfoForm.containerNumber != "" &&
        that.editPutCarDriverInfoForm.containerNumber != "无" &&
        that.editPutCarDriverInfoForm.cabinetType != "散装"
      ) {
        let reg = /^[0-9a-zA-Z]*$/;

        if (!reg.test(that.editPutCarDriverInfoForm.containerNumber)) {
          this.$message({
            message: "请输入正确的柜号，正确格式为字母、字数",
            type: "error",
          });
          return false;
        }
      }
      if (
        that.editPutCarDriverInfoForm.soNumber != null &&
        that.editPutCarDriverInfoForm.soNumber != "" &&
        that.editPutCarDriverInfoForm.soNumber != "无" &&
        that.editPutCarDriverInfoForm.cabinetType != "散装"
      ) {
        let reg = /^[0-9a-zA-Z]*$/;
        if (!reg.test(that.editPutCarDriverInfoForm.soNumber)) {
          this.$message({
            message: "请输入正确的SO号，正确格式为字母、字数",
            type: "error",
          });
          return false;
        }
      }
      const loading = this.$loading({
        lock: true,
        text: "请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      SaveMakeUpLogisticsInfo(that.editPutCarDriverInfoForm).then((res) => {
        loading.close();
        if (res.status === 200 && res.success) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.editPutCarDriverInfoVisible = false;
          this.initTable();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    makeUpLogisticsInfo() {
      this.editPutCarDriverInfoForm = {};
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      //  if (this.selectRows.rows[0].status == 50) {
      //   this.$message({
      //     message: "选择单据已复核同步，不允许补录！",
      //     type: "error",
      //   });
      //   return;
      // }

      this.editPutCarDriverInfoVisible = true;

      GetPutCarDriverInfo({
        loadCarInfoID: row[0].loadCarInfoID,
      }).then((res) => {
        this.editPutCarDriverInfoForm = res.response;
      });

      GetContainerTypeList({}).then((res) => {
        this.ContainerTypeList = res.data.response;
      });
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
    this.getBasicdatalist();
    getOperatorInfo().then((res) => {
      this.userList = res.data.response;
    });
  },
};
</script>

<style lang="less">
.content-az {
  overflow-x: hidden;
}
.dialogClass {
  .el-dialog {
    .el-dialog__body {
      //border-top: 1px solid #dcdfe6;
      //border-bottom: 1px solid #dcdfe6;
      max-height: 2000px !important;
      min-height: 500px;
      overflow-y: hidden;
    }
  }
  .el-dialog.is-fullscreen {
    max-height: 2000px !important;
    min-height: 500px;
  }
}
</style>
<style type="text/css" media="print">
@page {
  margin-top: 5mm;
  margin-bottom: 9mm;
  padding-top: 5mm;
}
@media print {
  div.content {
    page-break-after: always;
  }
}
</style>
